import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const validateVoucher = async (code, cartToken, eventId) => {
  const body = {
    code,
    cart_token: cartToken,
    event: eventId,
  };
  const response = await axios.post(
    routes.validateVoucher,
    body,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default validateVoucher;
